import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/K200228" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/ismail-ahmed-ansari-27378720b/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <h4><i>ismail.nuces@gmail.com</i></h4>
    </footer>
  );
}

export default Footer;